import type { DiagnosticEventSender } from './types';

export function initErrorTracker(send: DiagnosticEventSender): () => void {
  const onError = (e: ErrorEvent) => {
    send({
      t: 'error',
      msg: e.message,
      stack: e.error?.stack?.slice(0, 500),
      file: e.filename,
    });
  };

  const onUnhandledRejection = (e: PromiseRejectionEvent) => {
    send({
      t: 'error',
      msg: String(e.reason?.message || e.reason),
      stack: e.reason?.stack?.slice(0, 500),
    });
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onUnhandledRejection);
  };
}
